import classNames from 'classnames';
import posthog from 'posthog-js';
import * as PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../lang';
import Icon, { Icons } from '../Icon/Icon';
import './SendReceiveButton.scss';

const ICON_SIZE = 24;

const SendReceiveButton = ({ type, onClick }) => {
	const localClick = () => {
		posthog.capture('send_button_clicked');

		onClick();
	};

	return (
		<div className={classNames('SendReceiveButton', type + 'Button')} onClick={localClick}>
			<div className='SendReceiveButton-border'>
				<div className='SendReceiveButton-content'>
					<div>{t(type)}</div>
					<Icon type={Icons[type === 'Send' ? 'Send' : 'Receive']} width={ICON_SIZE} height={ICON_SIZE} />
				</div>
			</div>
		</div>
	);
};

SendReceiveButton.propTypes = {
	type: PropTypes.oneOf(['Send', 'Receive']),
};

export default SendReceiveButton;
